import React from 'react'
import ExpenseReport, { ExpenseReportContext } from 'src/app/ExpenseReport/ExpenseReport'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { managerReviewReimbursementRouteProps } from 'src/navigation/routeProps'

const ManagerReviewReimbursementAppRoute: AppRoute = {
  id: AppLocation.ManagerReviewReimbursementDetail,
  routeProps: managerReviewReimbursementRouteProps,
  component: <ExpenseReport context={ExpenseReportContext.managerReview} />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ManagerReviewReimbursementAppRoute
